// routes.js
import Dashboard from '../pages/Dashboard';
import Login from '../pages/Login';

import BannerList from '../pages/banners/List';
import AddBanner from '../pages/banners/AddUpdate';

import Setting from '../pages/Setting';
import Account from '../pages/Account';
import UserList from '../pages/users/List';
import UserDetails from '../pages/users/Details';
import AddUpdateUser from '../pages/users/AddUpdate';

import PatientList from '../pages/patients/List';
import AddUpdatePatient from '../pages/patients/AddUpdate';
import PatientDetails from '../pages/patients/Details';

import AppointmentList from '../pages/appointments/List';
import AddUpdateAppointment from '../pages/appointments/AddUpdate';
import Checkup from '../pages/appointments/Checkup';
import AppointmentReminders from '../pages/appointment_reminders/List';

import ProductList from '../pages/products/List';
import AddUpdateProduct from '../pages/products/AddUpdate';

import OrderList from '../pages/orders/List';
import AddUpdateOrder from '../pages/orders/AddUpdate';
import OrderDetails from '../pages/orders/Details';

import CheckupTypeList from '../pages/checkup_types/List';
import AddUpdateCheckupType from '../pages/checkup_types/AddUpdate';

import InsuranceTypeList from '../pages/insurance_types/List';
import AddUpdateInsuranceType from '../pages/insurance_types/AddUpdate';

import PurchaseList from '../pages/purchases/List';
import AddUpdatePurchase from '../pages/purchases/AddUpdate';

import ExpenseList from '../pages/expenses/List';
import AddUpdateExpense from '../pages/expenses/AddUpdate';

import ProductCategoryList from '../pages/product_categories/List';
import AddUpdateProductCategory from '../pages/product_categories/AddUpdate';

import ExpenseCategoryList from '../pages/expense_categories/List';
import AddUpdateExpenseCategory from '../pages/expense_categories/AddUpdate';

import SalesReport from '../pages/reports/SalesReport';
import PurchaseReport from '../pages/reports/PurchaseReport';
import ExpenseReport from '../pages/reports/ExpenseReport';
import InventoryReport from '../pages/reports/InventoryReport';
import OutstandingBalanceReport from '../pages/reports/OutstandingBalanceReport';
import SpecialistClinicReport from '../pages/reports/SpecialistClinicReport';
import PatientVisitHistory from '../pages/reports/PatientVisitHistory';

import SpecialistVisitList from '../pages/specialist_visits/List';
import AddUpdateSpecialistVisit from '../pages/specialist_visits/AddUpdate';
import SpecialistVisitDetails from '../pages/specialist_visits/Details';
import SpecialistCheckup from '../pages/specialist_visits/SpecialistCheckup';

import SupplierList from '../pages/suppliers/List';
import AddUpdateSupplier from '../pages/suppliers/AddUpdate';

import LensTypeList from '../pages/lens_types/List';
import AddUpdateLensType from '../pages/lens_types/AddUpdate';

import PermissionsPage from '../pages/permissions/Index';

import NotFound from '../pages/NotFound';


const routes = [
    {
        path: '/dashboard',
        component: Dashboard,
        meta: { requiresAuth: true, hideHeader: false, permission: null }
    },

    {
        path: '/login',
        component: Login,
        meta: { requiresAuth: false, hideHeader: true, permission: null }
    },
    {
        path: '/banners',
        component: BannerList,
        meta: { requiresAuth: true, hideHeader: false, permission: null }
    },
    {
        path: '/banners/add',
        component: AddBanner,
        meta: { requiresAuth: true, hideHeader: false, permission: null }
    },
    {
        path: '/banners/edit/:id',
        component: AddBanner,
        meta: { requiresAuth: true, hideHeader: false, permission: null }
    },

    {
        path: '/users/',
        component: UserList,
        meta: { requiresAuth: true, hideHeader: false, permission: 'users' }
    },
    {
        path: '/users/create',
        component: AddUpdateUser,
        meta: { requiresAuth: true, hideHeader: false, permission: 'users' }
    },
    {
        path: '/users/edit/:id',
        component: AddUpdateUser,
        meta: { requiresAuth: true, hideHeader: false, permission: 'users' }
    },
    {
        path: '/users/:id',
        component: UserDetails,
        meta: { requiresAuth: true, hideHeader: false, permission: 'users' }
    },

    // Patient Routes
    {
        path: '/patients',
        component: PatientList,
        meta: { requiresAuth: true, hideHeader: false, permission: 'patients' }
    },
    {
        path: '/patients/create',
        component: AddUpdatePatient,
        meta: { requiresAuth: true, hideHeader: false, permission: 'patients' }
    },
    {
        path: '/patients/edit/:id',
        component: AddUpdatePatient,
        meta: { requiresAuth: true, hideHeader: false, permission: 'patients' }
    },
    {
        path: '/patients/:id',
        component: PatientDetails,
        meta: { requiresAuth: true, hideHeader: false, permission: 'patients' }
    },

    // Appointment Routes
    {
        path: '/appointments',
        component: AppointmentList,
        meta: { requiresAuth: true, hideHeader: false, permission: 'appointments' }
    },
    {
        path: '/appointments/create',
        component: AddUpdateAppointment,
        meta: { requiresAuth: true, hideHeader: false, permission: 'appointments' }
    },
    {
        path: '/appointments/edit/:id',
        component: AddUpdateAppointment,
        meta: { requiresAuth: true, hideHeader: false, permission: 'appointments' }
    },
    {
        path: '/appointments/:id/checkup',
        component: Checkup,
        meta: { requiresAuth: true, hideHeader: false, permission: 'appointments' }
    },
    {
        path: '/appointment-reminders',
        component: AppointmentReminders,
        meta: { requiresAuth: true, hideHeader: false, permission: 'appointment_reminders' }
    },

    // Product Routes
    {
        path: '/products',
        component: ProductList,
        meta: { requiresAuth: true, hideHeader: false, permission: 'products' }
    },
    {
        path: '/products/create',
        component: AddUpdateProduct,
        meta: { requiresAuth: true, hideHeader: false, permission: 'products' }
    },
    {
        path: '/products/edit/:id',
        component: AddUpdateProduct,
        meta: { requiresAuth: true, hideHeader: false, permission: 'products' }
    },

    // Order Routes
    {
        path: '/orders',
        component: OrderList,
        meta: { requiresAuth: true, hideHeader: false, permission: 'orders' }
    },
    {
        path: '/orders/create',
        component: AddUpdateOrder,
        meta: { requiresAuth: true, hideHeader: false, permission: 'orders' }
    },
    {
        path: '/orders/edit/:id',
        component: AddUpdateOrder,
        meta: { requiresAuth: true, hideHeader: false, permission: 'orders' }
    },
    {
        path: '/orders/:id',
        component: OrderDetails,
        meta: { requiresAuth: true, hideHeader: false, permission: 'orders' }
    },

    // Checkup Type Routes
    {
        path: '/checkup-types',
        component: CheckupTypeList,
        meta: { requiresAuth: true, hideHeader: false, permission: 'data_management' }
    },
    {
        path: '/checkup-types/create',
        component: AddUpdateCheckupType,
        meta: { requiresAuth: true, hideHeader: false, permission: 'data_management' }
    },
    {
        path: '/checkup-types/edit/:id',
        component: AddUpdateCheckupType,
        meta: { requiresAuth: true, hideHeader: false, permission: 'data_management' }
    },

    // Insurance Type Routes
    {
        path: '/insurance-types',
        component: InsuranceTypeList,
        meta: { requiresAuth: true, hideHeader: false, permission: 'data_management' }
    },
    {
        path: '/insurance-types/create',
        component: AddUpdateInsuranceType,
        meta: { requiresAuth: true, hideHeader: false, permission: 'data_management' }
    },
    {
        path: '/insurance-types/edit/:id',
        component: AddUpdateInsuranceType,
        meta: { requiresAuth: true, hideHeader: false, permission: 'data_management' }
    },

    // Purchase Routes
    {
        path: '/purchases',
        component: PurchaseList,
        meta: { requiresAuth: true, hideHeader: false, permission: 'purchases' }
    },
    {
        path: '/purchases/create',
        component: AddUpdatePurchase,
        meta: { requiresAuth: true, hideHeader: false, permission: 'purchases' }
    },
    {
        path: '/purchases/edit/:id',
        component: AddUpdatePurchase,
        meta: { requiresAuth: true, hideHeader: false, permission: 'purchases' }
    },

    // Expense Routes
    {
        path: '/expenses',
        component: ExpenseList,
        meta: { requiresAuth: true, hideHeader: false, permission: 'expenses' }
    },
    {
        path: '/expenses/create',
        component: AddUpdateExpense,
        meta: { requiresAuth: true, hideHeader: false, permission: 'expenses' }
    },
    {
        path: '/expenses/edit/:id',
        component: AddUpdateExpense,
        meta: { requiresAuth: true, hideHeader: false, permission: 'expenses' }
    },

    // Product Categories
    {
        path: '/product-categories',
        component: ProductCategoryList,
        meta: { requiresAuth: true, hideHeader: false, permission: 'data_management' }
    },
    {
        path: '/product-categories/create',
        component: AddUpdateProductCategory,
        meta: { requiresAuth: true, hideHeader: false, permission: 'data_management' }
    },
    {
        path: '/product-categories/edit/:id',
        component: AddUpdateProductCategory,
        meta: { requiresAuth: true, hideHeader: false, permission: 'data_management' }
    },

    // Expense Categories
    {
        path: '/expense-categories',
        component: ExpenseCategoryList,
        meta: { requiresAuth: true, hideHeader: false, permission: 'data_management' }
    },
    {
        path: '/expense-categories/create',
        component: AddUpdateExpenseCategory,
        meta: { requiresAuth: true, hideHeader: false, permission: 'data_management' }
    },
    {
        path: '/expense-categories/edit/:id',
        component: AddUpdateExpenseCategory,
        meta: { requiresAuth: true, hideHeader: false, permission: 'data_management' }
    },

    // Report Routes
    {
        path: '/reports/sales',
        component: SalesReport,
        meta: { requiresAuth: true, hideHeader: false, permission: 'reports' }
    },
    {
        path: '/reports/purchases',
        component: PurchaseReport,
        meta: { requiresAuth: true, hideHeader: false, permission: 'reports' }
    },
    {
        path: '/reports/expenses',
        component: ExpenseReport,
        meta: { requiresAuth: true, hideHeader: false, permission: 'reports' }
    },
    {
        path: '/reports/inventory',
        component: InventoryReport,
        meta: { requiresAuth: true, hideHeader: false, permission: 'reports' }
    },
    {
        path: '/reports/outstanding-balance',
        component: OutstandingBalanceReport,
        meta: { requiresAuth: true, hideHeader: false, permission: 'reports' }
    },
    {
        path: '/reports/specialist-clinic',
        component: SpecialistClinicReport,
        meta: { requiresAuth: true, hideHeader: false, permission: 'reports' }
    },
    {
        path: '/reports/patient-visit-history',
        component: PatientVisitHistory,
        meta: { requiresAuth: true, hideHeader: false, permission: 'reports' }
    },

    // Specialist Visits
    {
        path: '/specialist-visits',
        component: SpecialistVisitList,
        meta: { requiresAuth: true, hideHeader: false, permission: 'specialist_visits' }
    },
    {
        path: '/specialist-visits/create',
        component: AddUpdateSpecialistVisit,
        meta: { requiresAuth: true, hideHeader: false, permission: 'specialist_visits' }
    },
    {
        path: '/specialist-visits/edit/:id',
        component: AddUpdateSpecialistVisit,
        meta: { requiresAuth: true, hideHeader: false, permission: 'specialist_visits' }
    },
    {
        path: '/specialist-visits/:id',
        component: SpecialistVisitDetails,
        meta: { requiresAuth: true, hideHeader: false, permission: 'specialist_visits' }
    },
    {
        path: '/specialist-checkup/:id',
        component: SpecialistCheckup,
        meta: { requiresAuth: true, hideHeader: false, permission: 'specialist_visits' }
    },

    // Supplier Routes
    {
        path: '/suppliers',
        component: SupplierList,
        meta: { requiresAuth: true, hideHeader: false, permission: 'data_management' }
    },
    {
        path: '/suppliers/create',
        component: AddUpdateSupplier,
        meta: { requiresAuth: true, hideHeader: false, permission: 'data_management' }
    },
    {
        path: '/suppliers/edit/:id',
        component: AddUpdateSupplier,
        meta: { requiresAuth: true, hideHeader: false, permission: 'data_management' }
    },

    // Lens Type Routes
    {
        path: '/lens-types',
        component: LensTypeList,
        meta: { requiresAuth: true, hideHeader: false, permission: 'data_management' }
    },
    {
        path: '/lens-types/create',
        component: AddUpdateLensType,
        meta: { requiresAuth: true, hideHeader: false, permission: 'data_management' }
    },
    {
        path: '/lens-types/edit/:id',
        component: AddUpdateLensType,
        meta: { requiresAuth: true, hideHeader: false, permission: 'data_management' }
    },

    // Permissions Management
    {
        path: '/permissions',
        component: PermissionsPage,
        meta: { requiresAuth: true, hideHeader: false, permission: null }
    },

    {
        path: '/account/',
        component: Account,
        meta: { requiresAuth: true, hideHeader: false, permission: null }
    },
    {
        path: '/settings/',
        component: Setting,
        meta: { requiresAuth: true, hideHeader: false, permission: null }
    },

    {
        path: '*',
        component: NotFound,
        meta: { requiresAuth: true, hideHeader: false, permission: null }
    },
];

export default routes;
